export default __webpack_public_path__ + "static/media/03.a44376bd.png";